"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { BreadcrumbHomepage } from "@/components/sections/BreadcrumbHomepage";
import { TemporaryInscription } from "./sections/TemporaryInscription";
import { FindUsSection } from "@/components/sections/FindUsSection";

export default function Inscription() {
  return (
    <>
      <BannerSection title="Inscription" />
      <BreadcrumbHomepage className="bg-secondary text-primary" />
      <TemporaryInscription />
      <FindUsSection />
    </>
  );
}
